import CreativeType from '@/Enums/Creatives/CreativeType.enum';
import {
  ICreateDV360TicketsCreativePayload,
  IDV360TicketsCreative,
  IDV360TicketsCreativeFilters,
  IDV360TicketsCreativeFormData,
  IUpdateDV360TicketsCreativePayload,
} from '@/Interfaces/DV360Tickets/Creative.interface';
import { CREATIVES_DEFAULT_SORT } from '@/constants/creativeLibrary';
import { getSortFilter } from '@/helpers/grid/getSortFilter';
import { normalizeUrl } from '@/helpers/url';

export const transformDV360TicketsCreativeFilters = ({ sort, ...filters }: IDV360TicketsCreativeFilters) => {
  return {
    ...filters,
    sort: sort?.length ? getSortFilter(sort) : CREATIVES_DEFAULT_SORT,
  };
};

export const mapApiDV360TicketsCreativesToTableData = (creatives: IDV360TicketsCreative[]) => {
  return creatives.map(creative => ({
    ...creative,
    advertiserName: creative.advertiser.name,
  }));
};

export const dv360creativeFormDataToApiStructure = (
  formData: IDV360TicketsCreativeFormData,
  id?: number,
): ICreateDV360TicketsCreativePayload | IUpdateDV360TicketsCreativePayload => {
  const payload: ICreateDV360TicketsCreativePayload | IUpdateDV360TicketsCreativePayload = {
    name: formData.name,
    advertiserId: formData.advertiserId!,
    type: formData.type,
  };

  if (id) {
    (payload as IUpdateDV360TicketsCreativePayload).id = id;
  }

  const clickUrl = formData.clickUrl?.trim();

  if (clickUrl) {
    payload.clickUrl = normalizeUrl(clickUrl);
  }

  if (formData.type === CreativeType.YOUTUBE_LINK) {
    // YOUTUBE_URL_RULES makes the scheme optional, and the stored value is rendered as an href.
    (payload as IUpdateDV360TicketsCreativePayload).videoUrl = normalizeUrl(formData.videoUrl!);
  }

  // Edit mode renders no upload control, so there is nothing to carry over.
  if (formData.type === CreativeType.VIDEO && formData.file) {
    (payload as IUpdateDV360TicketsCreativePayload).file = formData.file as File;
  }

  return payload;
};

export const dv360creativeToFormData = (creative: IDV360TicketsCreative): IDV360TicketsCreativeFormData => ({
  name: creative.name,
  advertiserId: creative.advertiser.id,
  type: creative.type,
  videoUrl: creative.videoUrl,
  clickUrl: creative.clickUrl || '',
  file: null,
});
